export default __webpack_public_path__ + "assets/images/e1c3baff66fb7e580cab2c1e015dc8d6.svg";